import script from "./JaContent.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__